<div class="p-grid">
  <div *ngIf="editable" class="p-col-6 p-sm-12">
    <label>{{label}}</label>
    <div>
      <file-import
        [label]="fileTypes"
        [entityId]="entityId"
        [entityParent]="entityParent"
        [siteId]="siteId"
        [fileFormat]="'scanned'"
        (fileUploaded)="addDocument($event)">
      </file-import>
    </div>
  </div>
  <div class="p-col-6 p-sm-12">
    <label>Download Links</label>
    <div *ngIf="blobs.length > 0 && !downloading">
      <div class="link" *ngFor="let blob of blobs">
        <confirmation-button *ngIf="editable"
          [iconsOnly]="true"
          actionIcon="pi pi-times" actionText="Delete"
          confirmIcon="pi pi-times" confirmText="Delete"
          cancelIcon="pi pi-minus-circle" cancelText="Cancel"
          (actionConfirmed)="deleteFile(blob.id)">
        </confirmation-button>
        <a (click)="downloadFile(blob.id)" target="_blank">{{blob.fileType | camelCase}} {{blob.index}}</a>
      </div>
    </div>
    <div>
      <p *ngIf="blobs.length == 0 && !working">No files uploaded</p>
    </div>
    <div *ngIf="working">
      <p>
      <i class="pi pi-spin pi-spinner"></i>
        Checking for files...
      </p>
    </div>
    <div *ngIf="downloading">
      <p>
      <i class="pi pi-spin pi-spinner"></i>
        Retrieving file...
      </p>
    </div>
  </div>
</div>

